export default "__VITE_ASSET__CxPHxeME__"